// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"a4046be7","256":"a4046be7","372":"a4046be7"}[chunkId] + ".chunk.css";
};